import type { CreatePaymentOrderInput, DeleteRecordsInput, UpdatePaymentOrderInput } from '@shared/types';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listPaymentOrders() {
  return getDesktopApi().payments.listPaymentOrders();
}

export async function getPaymentOrderById(paymentOrderId: string) {
  return getDesktopApi().payments.getPaymentOrderById(paymentOrderId);
}

export async function createPaymentOrder(payload: CreatePaymentOrderInput) {
  return getDesktopApi().payments.createPaymentOrder(payload);
}

export async function updatePaymentOrder(payload: UpdatePaymentOrderInput) {
  return getDesktopApi().payments.updatePaymentOrder(payload);
}

export async function syncPaymentOrder(paymentOrderId: string) {
  return getDesktopApi().payments.syncPaymentOrder({ id: paymentOrderId });
}

export async function refreshPaymentOrder(paymentOrderId: string) {
  return getDesktopApi().payments.refreshPaymentOrder({ id: paymentOrderId });
}

export async function deletePaymentOrders(payload: DeleteRecordsInput) {
  return getDesktopApi().payments.deletePaymentOrders(payload);
}

export async function listDeletedPaymentOrders() {
  return getDesktopApi().payments.listDeletedPaymentOrders();
}

export async function restorePaymentOrders(payload: DeleteRecordsInput) {
  return getDesktopApi().payments.restorePaymentOrders(payload);
}

export async function purgePaymentOrders(payload: DeleteRecordsInput) {
  return getDesktopApi().payments.purgePaymentOrders(payload);
}
